import * as _ from "lodash";

export function determineCols(gridVals) {
  // initialize empty col arr
  const newColsArr = [];
  for (let i = 0; i <= 8; i++) {
    newColsArr[i] = [];
  }

  // essentially transposing rows arr
  gridVals.forEach((row, i) => {
    row.forEach((val, j) => {
      newColsArr[j].push(val);
    });
  });

  return newColsArr;
}

export function determineRows(gridVals) {
  // the gridVals are already an array of rows
  const newRowsArr = _.cloneDeep(gridVals);
  return newRowsArr;
}

export function determineSubgridIdx(row, col) {
  return Math.floor(col / 3) + Math.floor(row / 3) * 3;
}

export function determineSubgrids(gridVals) {
  // initialize empty subgrid arr
  const newSubgridsArr = [];
  for (let i = 0; i <= 8; i++) {
    newSubgridsArr[i] = [];
  }

  gridVals.forEach((row, i) => {
    row.forEach((val, j) => {
      // i is row number
      // j is col number

      const subgridIdx = determineSubgridIdx(i, j);

      newSubgridsArr[subgridIdx].push(val);
    });
  });

  return newSubgridsArr;
}

export function findMissingVals(arr) {
  // find values that will complete range(0,9)
  const idealArr = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  const missing = idealArr.filter((x) => !arr.includes(x));
  return missing;
}

export function findValidVals(rowIdx, colIdx, rows, cols, subgrids) {
  if ((rowIdx != undefined) & (colIdx != undefined)) {
    const subgridIdx = determineSubgridIdx(rowIdx, colIdx);

    const validRowVals = findMissingVals(rows[rowIdx]);
    const validColVals = findMissingVals(cols[colIdx]);
    const validSubgridVals = findMissingVals(subgrids[subgridIdx]);

    // valid values are the intersection of the missing values from the
    // row, col, and subgrid

    const validVals = [
      ...new Set(
        [...validRowVals]
          .filter((i) => validColVals.includes(i))
          .filter((j) => validSubgridVals.includes(j))
      ),
    ];

    return validVals;
  }
  return [];
}
